<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" LeadsPannel>
            <v-row>
              <v-col cols="12" LEADSPANEL>
                <v-card :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">shopping_cart</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">ارسال الاشعارات</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">ارسال الاشعارات للمستخدمين</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class=" py-0">
                        <v-row class="align-center">
                          <v-col cols="12" md="4" class="text-center py-1" BTN>
                            <v-autocomplete
                              :items="filterTypes"
                              v-model="filterUsersBy"
                              label="اختيار حسابات بحسب"
                              autocomplete="disabled"
                              outlined
                              @click.stop=""
                              :filter="filterObject"
                              hide-details
                              clearable
                              dense
                              :loading="loading"
                              item-value="value"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{item.text}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{item.text}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" BTN>
                            <v-autocomplete
                              :items="resource.users"
                              v-model="selectedUsers"
                              label="اختيار حسابات محددة"
                              autocomplete="disabled"
                              outlined
                              @click.stop=""
                              :filter="filterObject"
                              hide-details
                              clearable
                              multiple
                              dense
                              :loading="loading"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{item.name}} | {{item.id}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{item.name}} | {{item.id}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" BTN>
                            <v-autocomplete
                              :items="products"
                              v-model="selectedProducts"
                              label="منتجات"
                              autocomplete="disabled"
                              outlined
                              @click.stop=""
                              :filter="filterObject"
                              hide-details
                              clearable
                              multiple
                              dense
                              :loading="loading"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{item.item_name}} | {{item.sku}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{item.item_name}} | {{item.sku}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" BTN>
                            <v-autocomplete
                              :items="resource.countries"
                              v-model="selectedCountries"
                              label="الدول التي تم البيع فيها"
                              autocomplete="disabled"
                              outlined
                              @click.stop=""
                              :filter="filterObject"
                              hide-details
                              clearable
                              multiple
                              dense
                              :loading="loading"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{item.name}} | {{item.id}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{item.name}} | {{item.id}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" BTN>
                            <v-autocomplete
                              :items="resource.users"
                              v-model="excludeUsers"
                              label="حسابات للأستثناء"
                              autocomplete="disabled"
                              outlined
                              @click.stop=""
                              :filter="filterObject"
                              hide-details
                              clearable
                              multiple
                              dense
                              :loading="loading"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{item.name}} | {{item.id}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{item.name}} | {{item.id}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} text-center py-1`" BTN>
                            عدد المستخدمين {{count}}
                          </v-col>
                          <v-col cols="12" md="10" class="text-center pa-2">
                            <v-text-field
                              outlined
                              hide-details
                              dense
                              v-model="notification.title"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              label="العنوان"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="10" class="text-center pa-2">
                            <v-textarea
                              outlined
                              hide-details
                              v-model="notification.body"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              label="الرسالة"
                            ></v-textarea>
                          </v-col>
                          <v-col cols="12" md="10" class="text-center pa-2">
                            <v-text-field
                              outlined
                              hide-details
                              dense
                              v-model="notification.link"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              label="رابط"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="2" class="text-center pa-2">
                            <v-progress-circular v-if="loading" color="primary" :indeterminate="true"></v-progress-circular>
                          </v-col>
                          <v-col cols="12">
                            <v-divider></v-divider>
                          </v-col>
                          <v-col cols="12">
                            <h3 class="arFont">إشعارات التطبيق</h3>
                            <v-row>
                              <v-col cols="6">
                                <Field
                                  :field="imageField"
                                  :item="notification"
                                  @getUpload="getUpload"
                                />
                              </v-col>
                              <v-col cols="6">
                                <v-text-field v-model="notification.freq" label="Freq" type="number" :rules="[rules.required]" outlined dense min="1"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN>
                            <v-btn 
                              color="primary" 
                              block 
                              text
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="countUsers()">
                              حساب عدد المستخدمين
                              <v-icon right size="15">search</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN>
                            <v-btn 
                              color="success" 
                              block 
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="sendNotification()">
                              ارسال تنبيه وايميل
                              <v-icon right size="15">chevron_left</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN>
                            <v-btn 
                              color="success" 
                              block text
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="sendNotification(true)">
                              ارسال ايميل فقط
                              <v-icon right size="15">chevron_left</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="mx-auto">
                            <v-btn 
                              color="success" 
                              block text
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="sendNotification(false, true)">
                              إرسال تنبيه مع إشعار التطبيق
                              <v-icon right size="15">chevron_left</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="12" class="text-center pa-2">
                            <v-progress-circular v-if="loading" color="primary" :indeterminate="true"></v-progress-circular>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                        <Paging 
                          :resourceSettings="resourceSettings" 
                          :resource="resource"
                          @loadResource="loadResource"
                          @pageByNumber="pageByNumber"
                        />
                      </v-col>
                      <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-1 my-0`" v-for="(d, i) in resource.data" :key="i+'not'">
                        <v-row class="align-center elevation-2">
                          <v-col cols="10" :class="`${arabic?'arFont':'enFont'}`">
                            <div style="font-weight:bold;">{{d.title}}</div>
                            <div>{{d.body}}</div>
                            <div><a :href="d.link">link</a></div>
                          </v-col>
                          <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                            <v-btn color="error" text @click="deleteNotification(d.id)">delete</v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Paging from '@/components/Paging'
import json2csv from 'json2csv'
import LeadImport from '@/components/LeadImport'
import axios from 'axios';
import Field from '../components/Field.vue';
const headers = {'Accept': 'application/json'};

export default {
  components: { LeadImport, Paging, Field },
  data() {
    return {
      imageField: {
        name: "image",
        type: 'upload',
        label: 'image',
        info: {en: '', ar: ''}
      },
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      thirdPanel:false,
      selectedPanel:'firstPanel',
      subitems:[
        
      ],
      menu1:false,
      fromDate:null,
      menu2:false,
      toDate:null,
      statuses:[],
      selectedStatus:null,
      file:null,
      import_leads:null,
      excludeUsers:[],
      filterTypes:[
        {text:'جميع المستخدمين', value:'all_users'},
        { text: 'اختيار حسابات محددة', value: 'selected_users' },
        {text:'حسابات فعالة', value:'all_active'},
        {text:'حسابات تبيع منتج اخر 48 ساعة', value:'use_sku_recent'},
        {text:'حسابات تبيع منتج اخر شهر', value:'use_sku_month'},
      ],
      selectedCountries:[],
      filterUsersBy:null,
      products:[],
      selectedProducts:[],
      selectedUsers:[],
      notification:{
        freq: 1
      },
      count:0,
    }
  },
  methods: {
    getUpload(image) {
      this.notification.image = image.value
    },
    downloadTemplate(){
      window.open(`https://firebasestorage.googleapis.com/v0/b/ashyaatcrm.appspot.com/o/ninja%2FBulk%20Import%20Template%20-%20Ninja%20Sellers%20-%20NEW.xlsx?alt=media&token=2d019126-e400-45e9-95cd-3e14188cbaef`, '_blank').focus();
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('postResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
          this.$emit('snackbarNotification', `تم ايجاد ${this.resource.data.length} طلب`, 'success')
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      if(this.fromDate && this.toDate) {
        filter += `&filter[from]=${this.fromDate}&filter[to]=${this.toDate}`
      }
      if(this.selectedStatus) {
        filter += `&filter[status]=${this.selectedStatus}`
      }
      return filter
    },
    async filterLeads(){
      // console.log('filterLeads')
      await this.loadResource()
    },
    async loadProducts(){
      return new Promise(async (res, rej)=>{
        // let laraProducts = 
        let products = await axios.get('https://product.yervip.com/api/v1/products-all').then(x=>x.data.products)
        let subs = await axios.get('https://product.yervip.com/api/v1/products-all').then(x=>x.data.subs.map(x=>{return{...x, name:'Sub ' + x.name}}))
        this.products = [...subs, ...products]
        // let variants = [].concat(...laraProducts.filter(x=> x.variants.length).map(x=>x.variants.map(v=>{
        //   return {
        //     ...x,
        //     var_true:true,
        //     ...v,
        //     item_name:v.name,
        //   }
        // })))
        // let short_new_products = []
        // .concat(...laraProducts.map(x=>x.item_name))
        // .concat(...laraProducts.map(x=>x.name_ar))
        // .concat(...variants.map(x=>x.name))
        // let all = [...laraProducts, ...variants] // .filter(x=>!laraProducts.filter(y=> y.variants.length).map(y=>y.sku).includes(x.sku))
        // let new_products = all.map(x=>{
        //   return {
        //     ...x,
        //     img: x.image && x.image.url ? x.image.url : null,
        //     prices: x.prices? x.prices.map(p=>{
        //       return {
        //         ...p,
        //         country:p.country.name
        //       }
        //     }): []
        //   }
        // })
        res()

      })
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/notify' + '?' + this.buildFilter()})
          console.log(this.resource)
          await this.loadProducts()
          res()
        } else {
          // console.log('search', this.search)
          this.resource = await this.$store.dispatch('postResource', {resource:'/notify' + `-search?` + this.buildFilter(), value:{search:this.search}})
          console.log(this.resource)
          await this.loadProducts()
          res()
        }
        this.loading = false
        res()
      })
    },
    async exportResource(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let exp = await this.$store.dispatch('getResource', {resource:'/leads-export' + '?' + this.buildFilter()})
        this.exportSimpleData(exp, 'leads')
        this.loading = false
        res()
      })
    },
    exportSimpleData(data, name){
      let a = json2csv.parse(data)
      // console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'failed_export'
      link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    },
    guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
			var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
		},
    pickFile(){
      console.log(this.$refs)
      this.$refs.fileCSV.click()
    },
    async onFilePickedCSV (e) {
      const files = e.target.files
      var file = files[0];
      let rows = []
      let leads = []
      this.$papa.parse(file, {
          header: true,
          complete: (results) => {
              rows = results.data;
              for (let i = 0; i < rows.length; i++) {
              const row = rows[i];
              if(leads.map(x=>x.phone_number_1).includes(row.phone_number_1)) {
                let s = leads.findIndex(x=>x.phone_number_1 == row.phone_number_1)
                console.log('s', s)
                if(leads[s].order.length && leads[s].order.map(x=>x.sku).includes(row.sku)) {
                  let p = leads[s].order.findIndex(x=>x.sku == row.sku)
                  console.log('p', p)
                  leads[s].order[p].quantity = parseInt(leads[s].order[p].quantity) + parseInt(row.quantity)
                } else {
                  leads[s].order.push({sku:row.sku, quantity:row.quantity, sold_price:row.sold_price})
                }
              } else {
                let lead = {
                  country: row.country,
                  name: row.name,
                  address: row.address,
                  city: row.city,
                  free_delivery: row.free_delivery,
                  phone_number_1: row.phone_number_1,
                  phone_number_2: row.phone_number_2,
                  note: row.note,
                  business_name: row.business_name,
                  order:[
                    {sku:row.sku, quantity:row.quantity, sold_price:row.sold_price}
                  ]
                }
                leads.push(lead)
              }
            }
            this.import_leads = leads
            console.log(this.import_leads);
          }
      });
    },
    remove(i){
      this.import_leads.splice(i, 1)
    },
    async sendNotification(only_email, with_popup){
      this.loading = true
      let notification = {
        ...this.notification,
        exclude:this.excludeUsers,
        countries:this.selectedCountries,
        filter: this.filterUsersBy,
        skus: this.selectedProducts,
        selected_users:this.selectedUsers,
        only_email:only_email,
        with_popup: with_popup
      }
      let a = await this.$store.dispatch('postResource', {resource:`/notify`, value:notification}) 
      await this.loadResource()
      this.loading = false
    },
    async deleteNotification(id) {
      this.loading = true
      let a = await this.$store.dispatch('deleteResource', {resource:`/notify/${id}`}) 
      await this.loadResource()
      this.loading = false
    },
    async countUsers(){
      return new Promise(async(res, rej)=>{
        this.loading = true
        let notification_counter = {
        exclude:this.excludeUsers,
        countries:this.selectedCountries,
        filter: this.filterUsersBy,
        skus: this.selectedProducts,
        selected_users:this.selectedUsers,
      }
        let a = await this.$store.dispatch('postResource', {resource:`/admin-notifications-count`, value:notification_counter}) 
        console.log(a)
        this.count = a.count
        this.loading = false
        res(true)
      })
    },
    details(){

    }
  },
  computed:{
    countries(){
      return this.$store.state.countries
    },
    statuses_obj(){
      return this.$store.state.statuses_obj
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
    // this.$store.state.countries = await axios.get(`https://product.yervip.com/api/v1/countries-ninja`).then(x=>x.data)

  },
}
</script>

<style>

</style>